import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface Props {
  text: string;
  variant?: 'dark' | 'light';
  className?: string;
}

export default function MarkdownExplanation({ text, variant = 'dark', className = '' }: Props) {
  const borderClass = variant === 'dark' ? 'border-white/20' : 'border-gray-300';

  return (
    <div className={className}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
          strong: ({ children }) => <strong className="font-semibold">{children}</strong>,
          ul: ({ children }) => <ul className="list-disc pl-5 mb-2 space-y-1">{children}</ul>,
          ol: ({ children }) => <ol className="list-decimal pl-5 mb-2 space-y-1">{children}</ol>,
          table: ({ children }) => (
            <div className="overflow-x-auto my-2">
              <table className={`min-w-full border-collapse text-xs sm:text-sm border ${borderClass}`}>{children}</table>
            </div>
          ),
          th: ({ children }) => <th className={`border ${borderClass} px-2 py-1 text-left font-semibold`}>{children}</th>,
          td: ({ children }) => <td className={`border ${borderClass} px-2 py-1`}>{children}</td>,
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  );
}
